var reduce = require('../array/virtual/reduce');

var ArrayPrototype = Array.prototype;

module.exports = function (it) {
  var own = it.reduce;
  return it === ArrayPrototype || (it instanceof Array && own === ArrayPrototype.reduce) ? reduce : own;
};



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/es/instance/reduce.js
// module id = 990
// module chunks = 0